import { render, staticRenderFns } from "./TheForm.vue?vue&type=template&id=dd06a8b2&scoped=true&lang=pug"
import script from "./TheForm.vue?vue&type=script&lang=js"
export * from "./TheForm.vue?vue&type=script&lang=js"
import style0 from "./TheForm.vue?vue&type=style&index=0&id=dd06a8b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd06a8b2",
  null
  
)

export default component.exports